<h2 mat-dialog-title>Herkunft setzen</h2>

<div mat-dialog-content class="herkunft-pick-content">
  <p class="hint">Herkunftsbetrieb wählen – wie Herkunft setzen in der Gruppe.</p>

  <kiene-betriebskontakt-auswahl
    [config]="{
      showLandwirte: true,
      showHaendler: true,
      showSchlachthoefe: true,
      showAll: true,
      multiSelect: false,
      compact: true,
      title: 'Herkunftsbetrieb auswählen',
      placeholder: 'Betrieb suchen...'
    }"
    [selectedKontakte]="selectedKontakt ? [selectedKontakt] : []"
    (kontaktSelected)="onKontaktSelected($event)"
    (kontakteSelected)="onKontakteSelected($event)"
  >
  </kiene-betriebskontakt-auswahl>

  <section *ngIf="selectedKontakt" class="selected-card">
    <h4>Ausgewählter Betrieb</h4>
    <kiene-betriebskontakt-card
      [kontakt]="selectedKontakt"
      [config]="{
        showActions: false,
        showMenu: false,
        showFavorit: false,
        compact: true,
        showBadge: false,
        selectedMode: true
      }"
    >
    </kiene-betriebskontakt-card>
  </section>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="clear()">Herkunft entfernen</button>
  <button mat-stroked-button type="button" (click)="close()">Abbrechen</button>
  <button mat-flat-button color="primary" type="button" [disabled]="!selectedKontakt" (click)="apply()">
    Übernehmen
  </button>
</div>
